import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import theme from './config/theme';

// Import pages
import HomeView from './pages/HomeView';
import AllMedicines from './pages/AllMedicines';
import BeautyAndWellness from './pages/BeautyAndWellness';
import Membership from './pages/Membership';
import Cart from './pages/Cart';
import ViewProduct from './pages/ViewProduct';
import Consult from './pages/Consult';
import Lab from './pages/Lab';
import ConsultDoctor from './pages/ConsultDoctor';
import Doctors from './pages/Doctors';
import DoctorsPage from './pages/DoctorsPage';
import OtcProducts from './pages/OtcProducts';
import ViewOTC from './pages/ViewOTC';
import ViewRelatedProducts from './pages/ViewRelatedProducts';
import Checkout from './pages/Checkout';
import Prescriptions from './pages/Prescriptions';
import AboutUs from './pages/AboutUs';
import SearchResults from './pages/SearchResults';
import SearchTestView from './pages/SearchTestView';
import Login from './pages/Login';
import AddressBook from './pages/AddressBook';
import OrdersList from './pages/OrdersList';
import Profile from './pages/Profile';
import TermsAndConditions from './pages/TermsAndConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import PaymentPolicy from './pages/PaymentPolicy';
import ReturnPolicy from './pages/ReturnPolicy';
import EditorialPolicy from './pages/EditorialPolicy';
import ShippingPolicy from './pages/ShippingPolicy';

// Import layouts
import MainLayout from './components/layouts/MainLayout';
import SecuredLayout from './components/layouts/SecuredLayout';
import ScrollToTop from './components/ScrollToTop';
import ProtectedRoute from './components/auth/ProtectedRoute';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <ScrollToTop />
        <Routes>
          {/* Public routes */}
          <Route path="/" element={
            <MainLayout>
              <HomeView />
            </MainLayout>
          } />
          <Route path="/product/:id" element={
            <MainLayout>
              <ViewProduct />
            </MainLayout>
          } />
          <Route path="/otc/:id" element={
            <MainLayout>
              <ViewOTC />
            </MainLayout>
          } />
          <Route path="/product/:id/related" element={
            <MainLayout>
              <ViewRelatedProducts />
            </MainLayout>
          } />
          <Route path="/otc/:id/related" element={
            <MainLayout>
              <ViewRelatedProducts />
            </MainLayout>
          } />
          <Route path="/consult/doctors/:id" element={
            <MainLayout>
              <ConsultDoctor />
            </MainLayout>
          } />
          <Route path="/consult/doctors" element={
            <MainLayout>
              <Doctors />
            </MainLayout>
          } />
          <Route path="/allmedicines" element={
            <MainLayout>
              <AllMedicines />
            </MainLayout>
          } />
          <Route path="/otcproducts/" element={
            <MainLayout>
              <OtcProducts />
            </MainLayout>
          } />
          <Route path="/beautyandwellness" element={
            <MainLayout>
              <BeautyAndWellness />
            </MainLayout>
          } />
          <Route path="/consult" element={
            <MainLayout>
              <Consult />
            </MainLayout>
          } />
          <Route path="/lab" element={
            <MainLayout>
              <Lab />
            </MainLayout>
          } />
          <Route path="/about-us" element={
            <MainLayout>
              <AboutUs />
            </MainLayout>
          } />
          <Route path="/search" element={
            <MainLayout>
              <SearchResults />
            </MainLayout>
          } />
          <Route path="/search-test" element={
            <MainLayout>
              <SearchTestView />
            </MainLayout>
          } />
          <Route path="/login" element={
            <MainLayout>
              <Login />
            </MainLayout>
          } />
          <Route path="/terms-and-conditions" element={
            <MainLayout>
              <TermsAndConditions />
            </MainLayout>
          } />
          <Route path="/privacy-policy" element={
            <MainLayout>
              <PrivacyPolicy />
            </MainLayout>
          } />
          <Route path="/fees-and-payments-policy" element={
            <MainLayout>
              <PaymentPolicy />
            </MainLayout>
          } />
          <Route path="/return-refund-and-cancellation-policy" element={
            <MainLayout>
              <ReturnPolicy />
            </MainLayout>
          } />
          <Route path="/editorial-policy" element={
            <MainLayout>
              <EditorialPolicy />
            </MainLayout>
          } />
          <Route path="/shipping-and-delivery-policy" element={
            <MainLayout>
              <ShippingPolicy />
            </MainLayout>
          } />

          {/* Secured routes */}
          <Route path="/checkout" element={
            <MainLayout>
              <ProtectedRoute>
                <SecuredLayout>
                  <Checkout />
                </SecuredLayout>
              </ProtectedRoute>
            </MainLayout>
          } />
          <Route path="/DoctorsPage" element={
            <MainLayout>
              <ProtectedRoute>
                <SecuredLayout>
                  <DoctorsPage />
                </SecuredLayout>
              </ProtectedRoute>
            </MainLayout>
          } />
          <Route path="/cart" element={
            <MainLayout>
            
                <Cart />
           
            </MainLayout>
          } />
          <Route path="/membership" element={
            <MainLayout>
              <ProtectedRoute>
                <SecuredLayout>
                  <Membership />
                </SecuredLayout>
              </ProtectedRoute>
            </MainLayout>
          } />
          <Route path="/prescriptions" element={
            <MainLayout>
              <ProtectedRoute>
                <SecuredLayout>
                  <Prescriptions />
                </SecuredLayout>
              </ProtectedRoute>
            </MainLayout>
          } />
          <Route path="/addressbook" element={
            <MainLayout>
              <ProtectedRoute>
                <SecuredLayout>
                  <AddressBook />
                </SecuredLayout>
              </ProtectedRoute>
            </MainLayout>
          } />
          <Route path="/orderslist" element={
            <MainLayout>
              <ProtectedRoute>
                <SecuredLayout>
                  <OrdersList />
                </SecuredLayout>
              </ProtectedRoute>
            </MainLayout>
          } />
          <Route path="/profile" element={
            <MainLayout>
              <ProtectedRoute>
                <SecuredLayout>
                  <Profile />
                </SecuredLayout>
              </ProtectedRoute>
            </MainLayout>
          } />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;